"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var TooltipPrimitive = _interopRequireWildcard(require("@radix-ui/react-tooltip"));
require("./Tooltip.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? 'top' : _ref$side,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(TooltipPrimitive.Provider, {
    delayDuration: 500,
    disableHoverableContent: true
  }, /*#__PURE__*/React.createElement(TooltipPrimitive.Root, null, /*#__PURE__*/React.createElement(TooltipPrimitive.Trigger, {
    className: "tooltip-trigger-button"
  }, children), /*#__PURE__*/React.createElement(TooltipPrimitive.Portal, null, /*#__PURE__*/React.createElement(TooltipPrimitive.Content, {
    className: "tooltip-content",
    side: side,
    sideOffset: 5
  }, text, /*#__PURE__*/React.createElement(TooltipPrimitive.Arrow, {
    className: "tooltip-arrow"
  })))));
};
var _default = exports["default"] = Tooltip;